/**
 * @file: rn-fetch-blob.web.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
export default {};
